import React, { Component } from "react"
import Delete from "../../assets/img/ic-delete.svg"
import Rename from "../../assets/img/ic-rename.svg"
import Util from "../../utils/utils";
import CourseDetailTable from "../../components/layout/courses/table";
import AddToPlayListModal from "../../components/layout/modal/addToPlayList";
import InfoModal from "../../components/layout/modal/info";
import { Redirect } from "react-router-dom";
import axios from "axios";
import * as config from "../../config";
import Nav from "../../components/layout/nav/nav";
import ErrorModal from "../../components/layout/modal/error";
import DeleteModal from "../../components/layout/modal/delete";
import RenameModal from "../../components/layout/modal/rename";

const NavUrls = [
	{
		id : 1,
		class : "active",
		name : "دارالشفاء",
	}
];

class PlayListDetail extends Component
{
	constructor ( props )
	{
		super( props );

		this.state = {
			error : null,
			isLoaded : false,
			status : 200,
			renameShow : false,
			deleteShow : false,
			renameName : "",
			redirect : false,
			playlist_name : ""
		};

		this.params = this.props.match.params;

		this.showRenameModal = this.showRenameModal.bind( this );
		this.showDeleteModal = this.showDeleteModal.bind( this );

	}

	setRenameState = ( arg ) =>
	{
		this.setState( ( oldState ) => ( { ...oldState, renameName : arg.name } ) );
	};

	showRenameModal = () =>
	{
		this.setState( ( oldState ) => ( { ...oldState, renameShow : true } ) );
	};

	hideRenameModal = () =>
	{
		this.setState( ( oldState ) => ( { ...oldState, renameShow : false } ) );
	};

	showDeleteModal = () =>
	{
		this.setState( ( oldState ) => ( { ...oldState, deleteShow : true } ) );
	};

	hideDeleteModal = () =>
	{
		this.setState( ( oldState ) => ( { ...oldState, deleteShow : false } ) );
	};

	getData ( token )
	{
		try
		{
			const params = this.props.match.params;

			axios.post( config.api_url + "/playlist/" + params.id, {}, {
				timeout : 30000,
				headers : {
					'Content-Type' : 'application/json',
					'Authorization' : token,
				}
			} ).then( res =>
			{
				if ( res.data.status )
				{
					let resData = res.data;

					this.setState( ( oldState ) => ( {
						...oldState,
						isLoaded : true,
						status : 200,
						items : resData,
						error : null,
						playlist_name : resData.playlist_name
					} ) );

					// if ( resData.last_item !== undefined &&  resData.last_item.title !== undefined && resData.last_item.title !== "" && resData.is_active )
					// {
					// 	let url = config.server_file_url + Util.encodeJwt( {
					// 		"item_id" : resData.last_item.id,
					// 		"exp" : parseInt( Date.now() / 1000 ) + ( 12 * 60 * 60 )
					// 	} );
					//
					// 	if ( resData.last_item.data_type === "0" )
					// 	{
					// 		dataService.setData( {
					// 			"name" : resData.last_item.title,
					// 			"isPlaying" : true,
					// 			"volumeStatus" : true,
					// 			"mediaRate" : 1,
					// 			"item_type" : 0,
					// 			"currentTime" : parseInt( resData.last_item.time ),
					// 			"item_id" : resData.last_item.id,
					// 			"url" : url
					// 		} );
					// 	}
					// 	else
					// 	{
					// 		dataService.setData( {
					// 			"name" : resData.last_item.title,
					// 			"isPlaying" : true,
					// 			"currentTime" : 0,
					// 			"mediaRate" : 1,
					// 			"volumeStatus" : true,
					// 			"item_id" : resData.last_item.id,
					// 			"item_type" : 1,
					// 			"url" : url,
					// 			"videoJsOptions" : {
					// 				autoplay : true,
					// 				controls : false,
					// 				responsive : false,
					// 				fluid : false,
					// 				fill : false,
					// 				playbackRates: [1, 1.25, 1.5, 1.75, 2],
					// 				sources : [ {
					// 					src : url,
					// 					type : 'video/mp4'
					// 				} ]
					// 			}
					// 		} );
					// 	}
					//
					// }

				}
				else
				{
					this.setState( ( oldState ) => ( {
						...oldState,
						redirect : true
					} ) );
				}

			} ).catch( error =>
			{
				this.setState( ( oldState ) => ( {
					...oldState,
					isLoaded : true,
					status : 401,
					error
				} ) );
			} );

		}
		catch ( error )
		{
			this.setState( ( oldState ) => ( {
				...oldState,
				isLoaded : true,
				status : 401,
				error
			} ) );
		}
	}

	submitDelete = async () =>
	{
		const token = "Bearer " + Util.getSession( "token" );
		// const params = this.props.match.params;

		let bodyFormData = new FormData();

		bodyFormData.append( 'playlist_id', this.params.id );

		let response = await axios.post( config.api_url + "/playlist/delete", bodyFormData, {
			timeout : 30000,
			headers : {
				'Content-Type' : 'application/x-www-form-urlencoded',
				'Authorization' : token,
			}
		} );

		if ( response.data.status )
		{
			this.setState( ( oldState ) => ( { ...oldState, redirect : true } ) );
		}
	};

	submitRename = async () =>
	{
		const token = "Bearer " + Util.getSession( "token" );


		let bodyFormData = new FormData();

		bodyFormData.append( 'playlist_id', this.params.id );
		bodyFormData.append( 'playlist_name', this.state.renameName );

		let response = await axios.post( config.api_url + "/playlist/edit", bodyFormData, {
			timeout : 30000,
			headers : {
				'Content-Type' : 'application/x-www-form-urlencoded',
				'Authorization' : token,
			}
		} );

		if ( response.data.status )
		{
			this.setState( ( oldstate ) => ( {
				...oldstate,
				playlist_name : this.state.renameName,
				renameShow : false
			} ) );
		}

	};

	CheckToken ( token )
	{
		try
		{
			axios.post( config.api_url + "/account/refresh-token", {}, {
				timeout : 30000,
				headers : {
					'Content-Type' : 'application/json',
					'Authorization' : token,
				}
			} ).then( res =>
			{
				if ( res.data.status )
				{
					Util.setSession( "token", res.data.token );
				}

				const token = "Bearer " + Util.getSession( "token" );
				this.getData( token );

			} ).catch( error =>
			{

			} );

		}
		catch ( error )
		{

		}
	}


	componentDidMount ()
	{
		this.CheckToken( "Bearer " + Util.getSession( "token" ) );
	}

	componentDidUpdate ( prevProps: Readonly<P>, prevState: Readonly<S>, snapshot: SS ): void
	{
		Util.convertNumberToPersion( document.body );
	}

	handleRefresh = () =>
	{
		this.setState( ( oldstate ) => ( { ...oldstate, errorShow : false } ) );
		window.location.reload();
	};

	render ()
	{
		const token = Util.getSession( "token" );

		if ( !token )
			return <Redirect to="/login"/>;

		const { error, isLoaded, items, redirect } = this.state;

		if ( redirect )
			return <Redirect to="/playlist"/>;

		if ( error )
		{
			return (
				<ErrorModal show={true} handleRefresh={this.handleRefresh} title="خطا!" buttonStatus={true} message="در دریافت اطلاعات مشکلی به وجود آمده است!" style={{
					"color" : "red",
					"fontSize" : "50px"
				}} iconName="fa-close"/>
			);
		}
		else if ( !isLoaded )
		{
			return (
				<ErrorModal show={true} handleRefresh={this.handleRefresh} title="لطفا منتظر بمانید" buttonStatus={false} message="در حال دریافت اطلاعات ..." style={{
					"color" : "white",
					"fontSize" : "50px"
				}} iconName="fa-refresh fa-spin"/>
			);
		}
		else
		{
			let listItems = items.items;
			let playList = items.playList;

			return (
				<>
					<DeleteModal show={this.state.deleteShow} message={" پلی لیست " + this.state.playlist_name} handleClose={this.hideDeleteModal} handleDelete={this.submitDelete}/>
					<RenameModal show={this.state.renameShow} handleClose={this.hideRenameModal} handleRename={this.submitRename} setRenameState={this.setRenameState}/>
					<main>
						<Nav urls={NavUrls}/>
						<section className="playlist-details-section row">
							<div className="col-sm-4 col-12 playlist-details-section-div row m-0 p-0">
								<h1 className="playlist-detail-title">
									{this.state.playlist_name}
								</h1>
								<div className="col-12 playlist-detail-decription-div order-sm-1 order-2" onClick={( e ) => this.setState( ( oldState ) => ( {
									...oldState,
									deleteShow : true
								} ) )}>
									<p className="playlist-detail-decription m-0">
										<img className="ml-2" src={Delete} alt=""/> حذف پلی‌لیست </p>
								</div>
								<div className="col-12 playlist-detail-decription-div order-sm-1 order-2" onClick={( e ) => this.setState( ( oldState ) => ( {
									...oldState,
									renameShow : true
								} ) )}>
									<p className="playlist-detail-decription m-0">
										<img className="ml-2" src={Rename} alt=""/> تغییر نام پلی‌لیست </p>
								</div>
							</div>
							<div className="col-sm-8 col-12 course-subjects">
								<div className="course-subject-div">
									<CourseDetailTable itemList={listItems} playList={playList} type="playlist" playlist_id={this.params.id}/>
								</div>
							</div>
						</section>
						<AddToPlayListModal/> <InfoModal/>
					</main>
				</>
			)
		}
	}
}

export default PlayListDetail;